import { render, staticRenderFns } from "./TaggedGalleryProperty.vue?vue&type=template&id=45c9dda0&scoped=true&"
import script from "./TaggedGalleryProperty.vue?vue&type=script&lang=js&"
export * from "./TaggedGalleryProperty.vue?vue&type=script&lang=js&"
import style0 from "./TaggedGalleryProperty.vue?vue&type=style&index=0&id=45c9dda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9dda0",
  null
  
)

export default component.exports